export const CLIENT_GET_USER_TOKEN = "ClientGetUserToken";
export const CLIENT_LIST_USER_TOKENS = "ClientListUserTokens";
